import type { FC, SVGProps } from 'react';
import React from 'react';

type IconProps = SVGProps<SVGSVGElement>;

export const VolumeLoudIcon: FC<IconProps> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9061 3.87817C11.0204 3.77472 11.1861 3.74906 11.3246 3.81128C11.4653 3.8735 11.5556 4.0135 11.5556 4.16672V15.8334C11.5556 15.9866 11.4653 16.1266 11.3246 16.1888C11.274 16.2114 11.2203 16.2223 11.1667 16.2223C11.0726 16.2223 10.9792 16.1881 10.9061 16.1219L7.13078 12.7207L4.94444 12.7223C4.30122 12.7223 3.77778 12.1988 3.77778 11.5556V8.4445C3.77778 7.80128 4.30122 7.27783 4.94444 7.27783H7.13389L10.9061 3.87817ZM14.6613 6.23196C15.6677 7.2384 16.2223 8.57696 16.2223 10.0003C16.2223 11.4236 15.6677 12.7622 14.6613 13.7678L14.1114 13.218C14.9709 12.3585 15.4445 11.2152 15.4445 10.0003C15.4445 8.78462 14.9709 7.64129 14.1114 6.78185L14.6613 6.23196ZM13.323 7.58545C13.939 8.24267 14.2781 9.09978 14.2781 9.99967C14.2781 10.9003 13.939 11.7575 13.3238 12.4147L12.756 11.8827C13.2359 11.3709 13.5003 10.702 13.5003 9.99967C13.5003 9.29811 13.2359 8.63 12.756 8.11745L13.323 7.58545Z"
      fill="white"
      fillOpacity="0.8"
    />
  </svg>
);
